const LOG_PREFIX = "[deployment]";

/** Emit a warning only in non-production builds. */
export function devWarn(message: string, detail?: unknown): void {
  if (
    typeof process !== "undefined" &&
    process.env &&
    process.env.NODE_ENV === "development"
  ) {
    if (detail !== undefined) {
      console.warn(LOG_PREFIX, message, detail);
    } else {
      console.warn(LOG_PREFIX, message);
    }
  }
}
